import React from "react";

import { IInput } from "./interfaces";

interface IFormContext {
  inputs: IInput[];
  register: (input: IInput) => void;
  unregister: (input: IInput) => void;
  validate: () => boolean;
  quiet?: boolean;
}

const FormContext = React.createContext<IFormContext>({
  inputs: [],
  register: () => {},
  unregister: () => {},
  validate: () => {
    return true;
  },
  quiet: false,
});

export { FormContext };
